import { useEffect, useState } from "react";
import { ArrowLeft, ArrowUpRight, Calendar, MapPin, Sparkles, Trophy, Users } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";

import Layout from "../../components/Layout";
import api, { formatApiError } from "../../lib/api";
import { Badge } from "../../components/ui/badge";

export default function DanceAnalysis() {
  const navigate = useNavigate();
  const [competitions, setCompetitions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/competitions/judging")
      .then((r) => setCompetitions(r.data))
      .catch((err) => toast.error(formatApiError(err)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <Link to="/responsabile" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 mb-6" data-testid="back-to-resp">
        <ArrowLeft className="h-4 w-4" /> Torna all'area
      </Link>

      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.25em] text-blue-700 font-bold">Pannello Giudicante</p>
        <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mt-2">Dance Analysis</h1>
        <p className="text-slate-500 mt-2">Le competizioni per le quali sei chiamato/a a giudicare.</p>
      </div>

      {loading ? (
        <div className="p-10 text-center text-slate-500 text-sm">Caricamento…</div>
      ) : competitions.length === 0 ? (
        <div className="bg-white rounded-2xl ring-1 ring-slate-200 p-12 text-center">
          <div className="h-16 w-16 rounded-2xl bg-indigo-50 text-indigo-700 flex items-center justify-center mx-auto">
            <Sparkles className="h-8 w-8" />
          </div>
          <h2 className="font-display text-xl font-semibold text-slate-900 mt-5">Nessuna competizione assegnata</h2>
          <p className="text-slate-500 mt-2 max-w-md mx-auto text-sm">
            Quando un Responsabile ti designerà come giudice e invierà la sua competizione, la troverai qui.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
          {competitions.map((c) => (
            <button
              key={c.id}
              onClick={() => navigate(`/responsabile/dance-analysis/${c.id}`)}
              className="group bg-white text-left rounded-2xl ring-1 ring-slate-200 hover:ring-indigo-300 hover:shadow-md hover:-translate-y-0.5 transition-all p-6 flex flex-col gap-3"
              data-testid={`judging-comp-${c.id}`}
            >
              <div className="flex items-start justify-between">
                <div className="h-10 w-10 rounded-lg bg-indigo-50 text-indigo-700 flex items-center justify-center">
                  <Trophy className="h-5 w-5" />
                </div>
                <ArrowUpRight className="h-5 w-5 text-slate-300 group-hover:text-slate-700 transition" />
              </div>
              <h3 className="font-display text-lg font-semibold text-slate-900">{c.name}</h3>
              <div className="text-sm text-slate-600 flex items-center gap-2"><MapPin className="h-4 w-4 text-slate-400" /> {c.location}</div>
              <div className="text-sm text-slate-600 flex items-center gap-2"><Calendar className="h-4 w-4 text-slate-400" /> {new Date(c.date).toLocaleDateString("it-IT", { day: "2-digit", month: "long", year: "numeric" })}</div>
              <div className="text-sm text-slate-500 flex items-center gap-2 mt-1"><Users className="h-4 w-4 text-slate-400" /> {c.athletes?.length || 0} atleti da valutare</div>
              <Badge className="bg-indigo-100 text-indigo-700 hover:bg-indigo-100 self-start mt-1">Apri pannello giudizio</Badge>
            </button>
          ))}
        </div>
      )}
    </Layout>
  );
}
